import Http from '@/services/http';
import {
  FinalGradientChartQuery,
  FinalGradientStatus,
  FinalGradientWinding,
  FinalGradientParametersRequest,
  FinalGradientParametersResponse,
  FinalGradientExpectedFinalTemperature,
  FinalGradientChart,
} from 'sigma-mappings';
import { grammaticalJoin } from '@/services/arrayUtils';
import mappingFields from '@/domain/data/installation/engineering/finalGradient/mappingFields';
import translate from '@/services/translate';

/* istanbul ignore next */
const errors = {
  errorHandling: {
    responseMessageParams: {
      $MA078: (data) => {
        const parameters = Object.entries(data.parameters);
        const commutator = parameters[0][1];
        const variablesArray = parameters
          .slice(1, parameters.length)
          .map(item => item[1]);
        const variables = grammaticalJoin(variablesArray);
        return {
          variables,
          commutator,
        };
      },
      $MA085: data => ({
        variable: data.parameters[0],
      }),
      $MA029: (data) => {
        if (!data || !data.parameters) return null;
        const returnedField = mappingFields[data.parameters[2]];
        return {
          FaixaInicial: data.parameters[0],
          FaixaFinal: data.parameters[1],
          NomeDoCampo: translate(returnedField),
        };
      },
      $MA001: (data) => {
        const parameters = Object.values(data.parameters);
        const variablesArray = parameters.map(item => translate(mappingFields[item]));
        const variables = grammaticalJoin(variablesArray);
        return {
          NomeDoCampo: variables,
        };
      },
      $MA092: (data) => {
        if (!data || !data.parameters) return null;
        const returnedField = mappingFields[data.parameters[0]];
        return {
          0: translate(returnedField),
          1: data.parameters[1],
        };
      },
    },
  },
};

const urls = {
  getStatus: assetModuleId => `engenharia/${assetModuleId}/gradiente-final/status`,
  getWinding: (assetModuleId, windingId) => `engenharia/${assetModuleId}/gradiente-final/enrolamentos/${windingId}`,
  getExpectedFinalTemperature: assetModuleId => `engenharia/${assetModuleId}/gradiente-final/temperatura-final-prevista`,
  parameters: assetModuleId => `engenharia/${assetModuleId}/gradiente-final/parametros`,
  getChart: assetModuleId => `engenharia/${assetModuleId}/gradiente-final/grafico`,
};

export { errors };

export default {
  getStatus(assetModuleId) {
    const http = new Http(errors);
    return http.get(urls.getStatus(assetModuleId))
      .then(({ data }) => new FinalGradientStatus(data));
  },
  getWinding(assetModuleId, windingId) {
    const http = new Http(errors);
    return http.get(urls.getWinding(assetModuleId, windingId))
      .then(({ data }) => new FinalGradientWinding(data));
  },
  getExpectedFinalTemperature(assetModuleId) {
    const http = new Http(errors);
    return http.get(urls.getExpectedFinalTemperature(assetModuleId))
      .then(({ data }) => data.map(item => new FinalGradientExpectedFinalTemperature(item)));
  },
  getParameters(assetModuleId) {
    const http = new Http(errors);
    return http.get(urls.parameters(assetModuleId))
      .then(({ data }) => new FinalGradientParametersResponse(data));
  },
  putParameters(assetModuleId, payload) {
    const http = new Http(errors);
    const mappedPayload = new FinalGradientParametersRequest(payload);
    return http.put(urls.parameters(assetModuleId), mappedPayload);
  },
  getChart(assetModuleId, chartFilters) {
    const http = new Http(errors);
    const chartQuery = new FinalGradientChartQuery(chartFilters);
    return http.get(urls.getChart(assetModuleId), { params: chartQuery })
      .then(({ data }) => data.map(item => new FinalGradientChart(item)));
  },
};
